import { render } from "./SectionButtons.vue?vue&type=template&id=56e59b2b&scoped=true"
import script from "./SectionButtons.vue?vue&type=script&lang=js"
export * from "./SectionButtons.vue?vue&type=script&lang=js"

import "./SectionButtons.vue?vue&type=style&index=0&id=56e59b2b&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e59b2b"]])

export default __exports__